import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import PayrollService from '../../services/PayrollService';

const initialState = {
    data: {},
    componentsData: {},
    benfitsData: {},
    columnConfig: [],
    status: 'idle'

};

export const fetchComponents = createAsyncThunk('components', async () => {
    const response = await PayrollService.getTenantComponentsData();
    return response;
});

export const fetchBenefits = createAsyncThunk('benefits', async () => {
    const response = await PayrollService.getTenantBenefitsData();
    return response;
});

export const fetchEmployeePayrolls = createAsyncThunk('processPayroll', async (payrunId) => {
    const response = await PayrollService.getPayrollOfPayrun(payrunId);
    return response;
});

export const resetEmployeePayrollData = createAsyncThunk('resetPayroll', async () => {
  return {};
})

export const ProcessPayrollSlice = createSlice({
    name: 'processPayroll',
    initialState,
    reducers: {
        processPayrollColumnConfig: (state, action) => {
            const configs = action.payload;
            let configsToStore = [];
            configs.forEach((config) => {
                configsToStore.push({
                    ...config,
                    key: config.columnCode,
                    options: config.options ? config.options : []
                });
            });
            state.columnConfig = configsToStore;
        },
        processColumnToPayrollColumnConfig: (state, action) => {
            state.columnConfig = [...state.columnConfig, action.payload];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployeePayrolls.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchEmployeePayrolls.fulfilled, (state, action) => {
                state.status = 'idle';
                state.data = action.payload;
            })
            .addCase(fetchEmployeePayrolls.rejected, (state, action) => {
                state.status = 'rejected';
                state.data = initialState;
            })
            .addCase(fetchComponents.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchComponents.fulfilled, (state, action) => {
                state.status = 'idle';
                state.componentsData = action.payload;
            })
            .addCase(fetchBenefits.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchBenefits.fulfilled, (state, action) => {
                state.status = 'idle';
                state.benfitsData = action.payload;
            })
            .addCase(resetEmployeePayrollData.pending, (state) => {
              state.status = 'loading';
            })
            .addCase(resetEmployeePayrollData.fulfilled, (state, action) => {
              state.status = 'idle';
              state.data = action.payload;
            })
    }
});


export const { processPayrollColumnConfig, processColumnToPayrollColumnConfig } =
ProcessPayrollSlice.actions;

export const seletcEmployeePayroll = (state) => state.processPayroll.data;

export const selectPayrollColumnConfig = (state) =>
    state.processPayroll.columnConfig;

export const selectTenantComponents = (state) => state.processPayroll.componentsData;

export const selectTenantBenfits = (state) => state.processPayroll.benfitsData;


    export default ProcessPayrollSlice.reducer